export const options = [
  { value: "bill_payments", label: "Bill Payments" },
  { value: "bill_vendors", label: "Bill Vendors" },
  { value: "clients", label: "Clients" },
  { value: "expenses", label: "Expenses" },
  { value: "expenses_categories", label: "Expenses Categories" },
  { value: "invoices", label: "Invoices" },
  { value: "items", label: "Items" },
  { value: "staff", label: "Staff" },
  { value: "tasks", label: "Tasks" },
  // { value: "projects", label: "Projects" },
  // { value: "time_entries", label: "Time Entries" },
];

export const clientsColumns = [
  {
    title: "User Name",
    dataIndex: "username",
    key: "username",
  },
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
  },
  {
    title: "First Name",
    dataIndex: "fname",
    key: "fname",
  },
  {
    title: "Last Name",
    dataIndex: "lname",
    key: "lname",
  },
  {
    title: "Organization",
    dataIndex: "organization",
    key: "organization",
  },
  {
    title: "Sign Up Date",
    dataIndex: "signup_date",
    key: "signup_date",
    render: (text, record) => (
      <span>{new Date(record?.signup_date).toLocaleDateString()}</span>
    ),
  },
  {
    title: "Currency Code",
    dataIndex: "currency_code",
    key: "currency_code",
  },
];

export const expensesColumns = [
  {
    title: "Account Id",
    dataIndex: "accounting_systemid",
    key: "accounting_systemid",
  },
  {
    title: "Account Name",
    dataIndex: "account_name",
    key: "account_name",
  },
  {
    title: "Date",
    dataIndex: "date",
    key: "date",
  },
  {
    title: "Amount",
    dataIndex: "amount",
    key: "amount",
    render: (text, record) => <span>{record?.amount?.amount || ""}</span>,
  },
  {
    title: "Billable",
    dataIndex: "billable",
    key: "billable",
    render: (text, record) => <span>{text.toString()}</span>,
  },
  {
    title: "Invoice Id",
    dataIndex: "invoiceid",
    key: "invoiceid",
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
  },
];

export const expensesCategoriesColumns = [
  {
    title: "Category Id",
    dataIndex: "categoryid",
    key: "categoryid",
  },
  {
    title: "Category",
    dataIndex: "category",
    key: "category",
  },
  {
    title: "Created At",
    dataIndex: "created_at",
    key: "created_at",
    render: (text, record) => (
      <span>{new Date(record?.created_at).toLocaleDateString()}</span>
    ),
  },
  {
    title: "Updated At",
    dataIndex: "updated_at",
    key: "updated_at",
    render: (text, record) => (
      <span>{new Date(record?.updated_at).toLocaleDateString()}</span>
    ),
  },
  {
    title: "Transaction Posted",
    dataIndex: "transaction_posted",
    key: "transaction_posted",
    render: (text, record) => <span>{text.toString()}</span>,
  },
  {
    title: "Status",
    dataIndex: "vis_state",
    key: "vis_state",
  },
];
export const staffColumns = [
  {
    title: "Name",
    dataIndex: "display_name",
    key: "display_name",
  },
  {
    title: "Username",
    dataIndex: "username",
    key: "username",
  },
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
  },
  {
    title: "Organization",
    dataIndex: "organization",
    key: "organization",
  },
  {
    title: "Sign Up Date",
    dataIndex: "signup_date",
    key: "signup_date",
    render: (text, record) => (
      <span>{new Date(record?.signup_date).toLocaleDateString()}</span>
    ),
  },
  {
    title: "Updated At",
    dataIndex: "updated",
    key: "updated",
    render: (text, record) => (
      <span>{new Date(record?.updated).toLocaleDateString()}</span>
    ),
  },
  {
    title: "Language",
    dataIndex: "language",
    key: "language",
  },
  {
    title: "Phone Number",
    dataIndex: "bus_phone",
    key: "bus_phone",
    render: (text, record) => (
      <span>{record?.bus_phone || record?.mob_phone}</span>
    ),
  },
];

export const vendorColumns = [
  {
    title: "Vendor Name",
    dataIndex: "vendor_name",
    key: "vendor_name",
  },
  {
    title: "Vendor ID",
    dataIndex: "vendorid",
    key: "vendorid",
  },
  {
    title: "Account Number",
    dataIndex: "account_number",
    key: "account_number",
  },
  {
    title: "City",
    dataIndex: "city",
    key: "city",
  },
  {
    title: "Country",
    dataIndex: "country",
    key: "country",
  },
  {
    title: "Created At",
    dataIndex: "created_at",
    key: "created_at",
    render: (text, record) => (
      <span>{new Date(record?.created_at).toLocaleDateString()}</span>
    ),
  },
  {
    title: "Currency Code",
    dataIndex: "currency_code",
    key: "currency_code",
  },
  {
    title: "Language",
    dataIndex: "language",
    key: "language",
  },
  {
    title: "Note",
    dataIndex: "note",
    key: "note",
  },
  {
    title: "Phone",
    dataIndex: "phone",
    key: "phone",
  },
  {
    title: "Postal Code",
    dataIndex: "postal_code",
    key: "postal_code",
  },
  {
    title: "Email",
    dataIndex: "primary_contact_email",
    key: "primary_contact_email",
  },
  {
    title: "First Name",
    dataIndex: "primary_contact_first_name",
    key: "primary_contact_first_name",
  },
  {
    title: "Last Name",
    dataIndex: "primary_contact_last_name",
    key: "primary_contact_last_name",
  },
  {
    title: "Province",
    dataIndex: "province",
    key: "province",
  },
  {
    title: "Street",
    dataIndex: "street",
    key: "street",
  },
  {
    title: "Street2",
    dataIndex: "street2",
    key: "street2",
  },
  {
    title: "Updated At",
    dataIndex: "updated_at",
    key: "updated_at",
    render: (text, record) => (
      <span>{new Date(record?.updated_at).toLocaleDateString()}</span>
    ),
  },
  {
    title: "Website",
    dataIndex: "website",
    key: "website",
  },
  {
    title: "Vis State",
    dataIndex: "vis_state",
    key: "vis_state",
  },
];

export const invoiceColumns = [
  {
    title: "Account ID",
    dataIndex: "accountid",
    key: "accountid",
  },
  {
    title: "Accounting System ID",
    dataIndex: "accounting_systemid",
    key: "accounting_systemid",
  },
  {
    title: "Address",
    dataIndex: "address",
    key: "address",
  },
  {
    title: "Amount",
    dataIndex: "amount",
    key: "amount",
    render: (text, record) => <span>{record?.amount?.amount || ""}</span>,
  },
  {
    title: "Currency Code",
    dataIndex: "currency_code",
    key: "currency_code",
  },
  {
    title: "Auto Bill",
    dataIndex: "auto_bill",
    key: "auto_bill",
    render: (text, record) => <span>{text.toString()}</span>,
  },
  {
    title: "City",
    dataIndex: "city",
    key: "city",
  },
  {
    title: "Code",
    dataIndex: "code",
    key: "code",
  },
  {
    title: "Country",
    dataIndex: "country",
    key: "country",
  },
  {
    title: "Created At",
    dataIndex: "created_at",
    key: "created_at",
    render: (text, record) => (
      <span>{new Date(record?.created_at).toLocaleDateString()}</span>
    ),
  },
  {
    title: "Current Organization",
    dataIndex: "current_organization",
    key: "current_organization",
  },
  {
    title: "Customer ID",
    dataIndex: "customerid",
    key: "customerid",
  },
  {
    title: "Date Paid",
    dataIndex: "date_paid",
    key: "date_paid",
  },
  {
    title: "Deposit Amount",
    dataIndex: "deposit_amount",
    key: "deposit_amount",
  },
  {
    title: "Deposit Percentage",
    dataIndex: "deposit_percentage",
    key: "deposit_percentage",
  },
  {
    title: "Deposit Status",
    dataIndex: "deposit_status",
    key: "deposit_status",
  },
  {
    title: "Description",
    dataIndex: "description",
    key: "description",
  },
  {
    title: "Discount Value",
    dataIndex: "discount_value",
    key: "discount_value",
  },
  {
    title: "Display Status",
    dataIndex: "display_status",
    key: "display_status",
  },
  {
    title: "Due Offset Days",
    dataIndex: "due_offset_days",
    key: "due_offset_days",
  },
  {
    title: "First Name",
    dataIndex: "fname",
    key: "fname",
  },
  {
    title: "Fulfillment Date",
    dataIndex: "fulfillment_date",
    key: "fulfillment_date",
  },
  {
    title: "Generation Date",
    dataIndex: "generation_date",
    key: "generation_date",
  },
  {
    title: "Gmail",
    dataIndex: "gmail",
    key: "gmail",
  },
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
  },
  {
    title: "Invoice Number",
    dataIndex: "invoice_number",
    key: "invoice_number",
  },
  {
    title: "Invoice ID",
    dataIndex: "invoiceid",
    key: "invoiceid",
  },
  {
    title: "Language",
    dataIndex: "language",
    key: "language",
  },
  {
    title: "Last Order Status",
    dataIndex: "last_order_status",
    key: "last_order_status",
  },
  {
    title: "Last Name",
    dataIndex: "lname",
    key: "lname",
  },
  {
    title: "Lock Status",
    dataIndex: "lock_status",
    key: "lock_status",
  },
  {
    title: "Notes",
    dataIndex: "notes",
    key: "notes",
  },
  {
    title: "Organization",
    dataIndex: "organization",
    key: "organization",
  },
  {
    title: "Owner ID",
    dataIndex: "ownerid",
    key: "ownerid",
  },
  {
    title: "Parent",
    dataIndex: "parent",
    key: "parent",
  },
  {
    title: "Payment Details",
    dataIndex: "payment_details",
    key: "payment_details",
  },
  {
    title: "Payment Status",
    dataIndex: "payment_status",
    key: "payment_status",
  },
  {
    title: "PO Number",
    dataIndex: "po_number",
    key: "po_number",
  },
  {
    title: "Province",
    dataIndex: "province",
    key: "province",
  },
  {
    title: "Return URI",
    dataIndex: "return_uri",
    key: "return_uri",
  },
  {
    title: "Sent ID",
    dataIndex: "sentid",
    key: "sentid",
  },
  {
    title: "Series",
    dataIndex: "series",
    key: "series",
  },
  {
    title: "Show Attachments",
    dataIndex: "show_attachments",
    key: "show_attachments",
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
  },
  {
    title: "Street",
    dataIndex: "street",
    key: "street",
  },
  {
    title: "Street2",
    dataIndex: "street2",
    key: "street2",
  },
  {
    title: "Template",
    dataIndex: "template",
    key: "template",
  },
  {
    title: "Terms",
    dataIndex: "terms",
    key: "terms",
  },
  {
    title: "Updated",
    dataIndex: "updated",
    key: "updated",
  },
  {
    title: "V3 Status",
    dataIndex: "v3_status",
    key: "v3_status",
  },
];

export const itemColumns = [
  {
    title: "Accounting System ID",
    dataIndex: "accounting_systemid",
    key: "accounting_systemid",
  },
  {
    title: "Description",
    dataIndex: "description",
    key: "description",
  },
  {
    title: "Domain",
    dataIndex: "domain",
    key: "domain",
  },
  {
    title: "Inventory",
    dataIndex: "inventory",
    key: "inventory",
  },
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Product Code",
    dataIndex: "product_code",
    key: "product_code",
  },
  {
    title: "Quantity",
    dataIndex: "qty",
    key: "qty",
  },
  {
    title: "Unit Cost Amount",
    dataIndex: "unit_cost",
    key: "unit_cost",
    render: (text, record) => <span>{record?.unit_cost?.amount || ""}</span>,
  },
  {
    title: "Updated",
    dataIndex: "updated",
    key: "updated",
    render: (text, record) => (
      <span>{new Date(record?.updated).toLocaleDateString()}</span>
    ),
  },
];

export const taskColumns = [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Billable",
    dataIndex: "billable",
    key: "billable",
  },
  {
    title: "Description",
    dataIndex: "description",
    key: "description",
  },
  {
    title: "Rate Amount",
    dataIndex: "rate",
    key: "rate",
    render: (text, record) => <span>{record?.rate?.amount || ""}</span>,
  },
  {
    title: "Task Name",
    dataIndex: "tname",
    key: "tname",
  },
  {
    title: "Updated",
    dataIndex: "updated",
    key: "updated",
    render: (text, record) => (
      <span>{new Date(record?.updated).toLocaleDateString()}</span>
    ),
  },
];

export const paymentColumns = [
  {
    title: "Bill ID",
    dataIndex: "billid",
    key: "billid",
  },
  {
    title: "Amount",
    dataIndex: "amount",
    key: "amount",
    render: (text, record) => <span>{record?.amount?.amount || ""}</span>,
  },
  {
    title: "Currency Code",
    dataIndex: "amount",
    key: "amount",
    render: (text, record) => <span>{record?.amount?.code || ""}</span>,
  },
  {
    title: "Note",
    dataIndex: "note",
    key: "note",
  },
  {
    title: "Paid Date",
    dataIndex: "paid_date",
    key: "paid_date",
    render: (text, record) => (
      <span>{new Date(record?.paid_date).toLocaleDateString()}</span>
    ),
  },
  {
    title: "Payment Type",
    dataIndex: "payment_type",
    key: "payment_type",
  },
  {
    title: "Vis State",
    dataIndex: "vis_state",
    key: "vis_state",
  },
];
